<h2 mat-dialog-title>{{value.filename}}</h2>
<mat-dialog-content>
  <img [alt]="value.filename" [src]="getImage()" style="object-fit: contain; max-height: 50vh; max-width: 45vw"/>
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin-top: auto">
  <button cdkFocusInitial mat-button mat-dialog-close>{{'keys.local.global.ok' | translate}}</button>
</mat-dialog-actions>
